import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TipoActivo } from 'src/app/models/enum/tipo-activo.enum';
import { TipoVehiculo } from 'src/app/models/enum/tipo-vehiculo.enum';
import { TipoBienesRaices } from 'src/app/models/enum/tipo-bienes-raices.enum';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { PersonaService } from 'src/app/services/persona.service';
import { StepperService } from 'src/app/services/stepper.service';

@Component({
  selector: 'app-activos',
  templateUrl: './activos.component.html',
  styleUrls: ['./activos.component.css']
})
export class ActivosComponent implements OnInit {
  formArray: FormArray<FormGroup<any>> = new FormArray<FormGroup<any>>([]);
  tipoActivos : TipoActivo | any = TipoActivo;
  tipoVehiculos : TipoVehiculo | any = TipoVehiculo;
  tipoBienesRaices : TipoBienesRaices | any = TipoBienesRaices;
  activos: any[] = [];
  persona: any;
  formFirmado = false;
  textoPreda= this.formArray.get('textoPreda')?.value || '';
  string = this.formArray.get('textoPreda')?.value || ''
  private estadoSituacionGuid: string = '';
  constructor(private fb: FormBuilder, private stepperService: StepperService, private dataService: DataService, private personaService: PersonaService) { }

  ngOnInit(): void {
    this.personaService.persona$.subscribe({
      next: (persona) => {
        if (persona) {
          this.persona = persona;
          this.estadoSituacionGuid = persona.estadoSituacion.guid;
          this.formArray = this.fb.array<FormGroup<any>>([]);
          if(persona.estadoSituacion.personaActivos?.length > 0){
            for (let i = 0; i < persona.estadoSituacion.personaActivos?.length; i++) {
              this.agregarActivo(persona.estadoSituacion.personaActivos[i]);
              this.tipoActivoChange(persona.estadoSituacion.personaActivos[i].tipoActivo, i);

              this.formArray.at(i).get('comentario')?.setValue(persona.estadoSituacion.personaActivos[i].comentario);
              this.formArray.at(i).get('Marca')?.setValue(persona.estadoSituacion.personaActivos[i].marca);
              this.formArray.at(i).get('Modelo')?.setValue(persona.estadoSituacion.personaActivos[i].modelo);
              this.formArray.at(i).get('Anio')?.setValue(persona.estadoSituacion.personaActivos[i].anio);
              this.formArray.at(i).get('detalle')?.setValue(persona.estadoSituacion.personaActivos[i].detalle);
              this.formArray.at(i).get('tipoVehiculo')?.setValue(persona.estadoSituacion.personaActivos[i].tipoVehiculo);
              this.formArray.at(i).get('tipoBienesRaices')?.setValue(persona.estadoSituacion.personaActivos[i].tipoBienesRaices);
              this.formArray.at(i).get('valorComercial')?.setValue(persona.estadoSituacion.personaActivos[i].valorComercial);
              this.prendaHipotecaChange(persona.estadoSituacion.personaActivos[i].prendaHipoteca, i);
              this.formArray.at(i).get('rolPatente')?.setValue(persona.estadoSituacion.personaActivos[i].rolPatente);
              this.formArray.at(i).get('saldoDeuda')?.setValue(persona.estadoSituacion.personaActivos[i].saldoDeuda);
              this.formArray.at(i).get('valorCuota')?.setValue(persona.estadoSituacion.personaActivos[i].valorCuota);

               if(persona.estadoSituacion.personaActivos[i].tipoActivo == 'Inversiones'){
                this.formArray.at(i).get('saldoDeuda')?.setValue(persona.estadoSituacion.personaActivos[i].saldoDeuda);
                this.formArray.at(i).get('valorCuota')?.setValue(persona.estadoSituacion.personaActivos[i].valorCuota);
                this.formArray.at(i).get('saldoDeuda')?.enable();
                this.formArray.at(i).get('valorCuota')?.enable();
              }
            }
          }else{
            this.agregarActivo(null)
          }
          if (persona.estadoSituacion?.estadoFormularioSituacion == 'Firmado') {
            this.formFirmado = true;
            this.formArray.disable();
          }
        }
      },
      error: (err) => console.log(err)
    });
    
  }

  agregarActivo(activo: any): void {
    if (this.formArray.length > 0 && this.formArray.at(this.formArray.length - 1).invalid) {
      this.formArray.at(this.formArray.length - 1).markAllAsTouched();
      return;
    }
    const nuevoActivo = this.fb.group({
      estadoSituacionId: new FormControl(this.estadoSituacionGuid),
      guid: new FormControl(activo?.guid),
      tipoActivo: new FormControl(activo?.tipoActivo, [Validators.required]),
      tipoVehiculo: new FormControl(activo?.tipoVehiculo ? activo?.tipoVehiculo : null),
      tipoBienesRaices: new FormControl(activo?.tipoBienesRaices ? activo?.tipoBienesRaices : null),
      comentario: new FormControl(activo?.comentario ? activo?.comentario : ''),
      detalle: new FormControl(activo?.detalle ? activo?.detalle : null),
      rolPatente: new FormControl(activo?.rolPatente, [Validators.required]),
      prendaHipoteca: new FormControl(false),
      saldoDeuda: new FormControl(activo?.saldoDeuda ? activo?.saldoDeuda : null, [Validators.required]),
      valorCuota: new FormControl(activo?.valorCuota ? activo?.valorCuota : null, [Validators.required]),
      valorComercial: new FormControl(activo?.valorComercial, [Validators.required]),
      Marca: new FormControl(activo?.Marca ? activo?.Marca : null),
      Modelo: new FormControl(activo?.Modelo ? activo?.Modelo : null),
      Anio: new FormControl(activo?.Anio ? activo?.Anio : null, [Validators.min(1900), Validators.max(new Date().getFullYear())]),
      textoRol:new FormControl(''),
      textoPreda: new FormControl('')
    });
    nuevoActivo.get('prendaHipoteca')?.disable();
    nuevoActivo.get('saldoDeuda')?.disable();
    nuevoActivo.get('valorCuota')?.disable();
    nuevoActivo.get('rolPatente')?.disable();
    this.formArray.push(nuevoActivo);
  }

  eliminarActivo(index: number): void {
    if (index >= 0 && index < this.formArray.length) {
      this.formArray.removeAt(index);
    }
  }

  onSubmit() {

    if(this.persona.estadoSituacion?.estadoFormularioSituacion == 'Firmado'){
      this.stepperService.nextStep();  
      return;
    }
    if(this.formArray.length == 1 && this.formArray.at(0).get('tipoActivo')?.value == null) {
      this.stepperService.nextStep();
      return;
    }
    if(!this.formArray.invalid) {
      this.removeNullGuid();
      const formData = this.formArray.value;
      formData.forEach((activo: any) => {
        if (activo.tipoActivo !== 'Vehiculos') {
          activo.tipoVehiculo = null;
        }
        if (activo.tipoActivo !== 'BienesRaices') {
          activo.tipoBienesRaices = null;
        }
      });
      console.log(formData);
      var url = `estado-situacion/${this.personaService.getPersonaGuid()}/activos`;
      this.dataService.postData(formData, url).subscribe({
        next: (v) => {
            this.stepperService.nextStep();
        },
        error: (e) => console.log(e),
        complete: () => {
          this.personaService.setPersona();
        },
      });
    }else{
      this.formArray.markAllAsTouched();
    }
  }

  removeNullGuid() {
    for (let i = 0; i < this.formArray.length; i++) {
      if(this.formArray.at(i).get('guid')?.value == null) {
        this.formArray.at(i).removeControl('guid');
      }
    }
  }

  getTipoActivo(): string[] {
    //dejar otros al final
    const sortedKeys = Object.keys(TipoActivo).sort(); 
    const otrosIndex = sortedKeys.indexOf('Otros');   
  
    if (otrosIndex > -1) {
      sortedKeys.splice(otrosIndex, 1); 
      sortedKeys.push('Otros');   
    }
  
    return sortedKeys;
  }

  getTipoVehiculo(): string[] {
    return Object.keys(TipoVehiculo);
  }
  getTipoBienesRaices(): string[] {
    return Object.keys(TipoBienesRaices);
  }

  tipoActivoChange(event: any, index: number) {
    const formGroup = this.formArray.at(index);
    const rolPatenteControl = formGroup.get('rolPatente');
    const valorComercialControl = formGroup.get('valorComercial');
    const tipoVehiculoControl = formGroup.get('tipoVehiculo');
    const tipoBienesRaicesControl = formGroup.get('tipoBienesRaices');
    const descripcionControl = formGroup.get('comentario');
    const Marca = formGroup.get('Marca');
    const Modelo = formGroup.get('Modelo');
    const Anio = formGroup.get('Anio');
    const detalleControl = formGroup.get('detalle');
    const prendaHipotecaControl = formGroup.get('prendaHipoteca');
    const saldoDeudaControl = formGroup.get('saldoDeuda');
    const valorCuotaControl = formGroup.get('valorCuota');
    const textPrenda = formGroup.get('textoPreda');
    const textRol = formGroup.get('textoRol');
  
    // Clear all validators
    rolPatenteControl?.clearValidators();
    valorComercialControl?.clearValidators();
    descripcionControl?.clearValidators();
    Marca?.clearValidators();
    Modelo?.clearValidators();
    Anio?.clearValidators();
    detalleControl?.clearValidators();
    saldoDeudaControl?.clearValidators();
    valorCuotaControl?.clearValidators();
    tipoVehiculoControl?.clearValidators();
    tipoBienesRaicesControl?.clearValidators();
    prendaHipotecaControl?.clearValidators();
  
    // Disable all controls
    rolPatenteControl?.disable();
    prendaHipotecaControl?.disable();
    Marca?.disable();
    Modelo?.disable();
    Anio?.disable();
    saldoDeudaControl?.disable();
    valorCuotaControl?.disable();
    tipoVehiculoControl?.disable();
    tipoBienesRaicesControl?.disable();
    
    detalleControl?.setValue('');
    prendaHipotecaControl?.setValue(false);
    descripcionControl?.setValue('');
    descripcionControl?.clearValidators();
    rolPatenteControl?.setValue('');
    Marca?.setValue('');
    Modelo?.setValue('');
    Anio?.setValue('');
    detalleControl?.setValue('');
    saldoDeudaControl?.setValue(null);
    valorCuotaControl?.setValue(null);
    textPrenda?.setValue('');
    textRol?.setValue('');
    valorComercialControl?.setValue(null);


  
    // Set validators and enable controls based on the selected type
    switch(event) {
      case 'Vehiculos':
        rolPatenteControl?.setValidators([Validators.required]);
        rolPatenteControl?.enable();
        prendaHipotecaControl?.enable();
        prendaHipotecaControl?.setValue(false);
        Marca?.setValidators([Validators.required]);
        Marca?.enable();
        Modelo?.setValidators([Validators.required]);
        Modelo?.enable();
        Anio?.setValidators([Validators.required, Validators.min(1900), Validators.max(new Date().getFullYear()), Validators.pattern(/^[0-9]{4}$/)]);
        Anio?.enable();
        tipoVehiculoControl?.setValidators([Validators.required]);
        tipoVehiculoControl?.enable();
        //comentario opcional vehiculos
        detalleControl?.setValue(' ');
        descripcionControl?.setValue(' ');
        descripcionControl?.clearValidators();
        descripcionControl?.updateValueAndValidity();
  
        textPrenda?.setValue('Credito / Prenda');
        textRol?.setValue('Patente');
        tipoBienesRaicesControl?.setValue(undefined);
        break;
      case 'BienesRaices':
        rolPatenteControl?.setValidators([Validators.required]);
        rolPatenteControl?.enable();
        prendaHipotecaControl?.enable();
        prendaHipotecaControl?.setValue(false);
        tipoBienesRaicesControl?.setValidators([Validators.required]);
        tipoBienesRaicesControl?.enable();
        //comentario opcional para bienes raices
        detalleControl?.setValue(' ');
        descripcionControl?.setValue(' ');
        descripcionControl?.clearValidators();
        descripcionControl?.updateValueAndValidity();
        textPrenda?.setValue('Hipoteca');
        textRol?.setValue('Rol');
        tipoVehiculoControl?.setValue(undefined);
        break;
      case 'Inversiones':
        tipoVehiculoControl?.setValue(undefined);
        tipoBienesRaicesControl?.setValue(undefined);
        detalleControl?.setValidators([Validators.required]);
        valorCuotaControl?.enable();
        valorCuotaControl?.setValidators([Validators.required]);
        saldoDeudaControl?.enable();
        saldoDeudaControl?.setValidators([Validators.required]);
        break;
      case 'Otro':
        tipoVehiculoControl?.setValue(undefined);
        tipoBienesRaicesControl?.setValue(undefined);
        detalleControl?.setValidators([Validators.required]);
        break;
      default:
        break;
    }
  
    // Set common validators
    valorComercialControl?.setValidators([Validators.required]);
  
    // Update value and validity for all controls
    rolPatenteControl?.updateValueAndValidity();
    valorComercialControl?.updateValueAndValidity();
    descripcionControl?.updateValueAndValidity();
    Marca?.updateValueAndValidity();
    Modelo?.updateValueAndValidity();
    Anio?.updateValueAndValidity();
    detalleControl?.updateValueAndValidity();
    saldoDeudaControl?.updateValueAndValidity();
    valorCuotaControl?.updateValueAndValidity();
  }

  prendaHipotecaChange(event: any, index: number) {
    if(event == true){
      this.formArray.at(index).get('saldoDeuda')?.enable();
      this.formArray.at(index).get('valorCuota')?.enable();
      this.formArray.at(index).get('saldoDeuda')?.setValue(null);
      this.formArray.at(index).get('valorCuota')?.setValue(null);
      this.formArray.at(index).get('saldoDeuda')?.setValidators([Validators.required]);
      this.formArray.at(index).get('valorCuota')?.setValidators([Validators.required]);
      this.formArray.at(index).get('prendaHipoteca')?.setValue(true);
      this.formArray.at(index).get('valorCuota')?.updateValueAndValidity();
      this.formArray.at(index).get('saldoDeuda')?.updateValueAndValidity();
    }else{
      this.formArray.at(index).get('saldoDeuda')?.disable();
      this.formArray.at(index).get('saldoDeuda')?.setValue(null);
      this.formArray.at(index).get('valorCuota')?.disable();
      this.formArray.at(index).get('valorCuota')?.setValue(null);
      this.formArray.at(index).get('prendaHipoteca')?.setValue(false);
    }
  }

  volver(){
    if(this.persona.identificacionPersona.tipoEstadoCivil != 'Casado' && this.persona.identificacionPersona.tipoEstadoCivil != 'ConvivienteCivil'){
      this.stepperService.setStepIndex(3);

    }
    else{
      this.stepperService.prevStep();
    }
    
  }
  
}
